import { render } from "./signUp0.vue?vue&type=template&id=fc2c3188"
import script from "./signUp0.vue?vue&type=script&lang=js"
export * from "./signUp0.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__